import { Link } from 'react-router-dom';
import news_5 from '../assets/images/resource/news-5.jpg';
import news_6 from '../assets/images/resource/news-3.jpg';
import news_7 from '../assets/images/resource/news-5.jpg';
import news_11 from '../assets/images/resource/news-11.jpg';
import news_12 from '../assets/images/resource/news-12.jpg';
import news_13 from '../assets/images/resource/news-11.jpg';

const Service1 = ({ }) => {
	return (
		<div>

			<section class="services-page-section">
				<div class="auto-container">
					{/* <div class="row clearfix"> */}
					<div class="row clearfix justify-content-center">


						{/* <!-- News Block Three --> */}
						<div class="news-block-three col-lg-4 col-md-6 col-sm-12">
							<div class="inner-box">
								<div class="image">
									<a href="/services/web-development/">
										<img src={news_5} alt="" />
									</a>
								</div>
								<div class="lower-content">
									<div class="content">
										<div class="icon-box">
											<span class="icon flaticon-coding-1"></span>
										</div>
										<h4><Link to="/services/web-development/">Web Development</Link></h4>
										<div class="text">Our team creates responsive, user-friendly websites that reflect your brand and deliver excellent experiences across all devices.</div>
										<a class="read-more" href="/services/web-development/">Read More<span class="arrow flaticon-long-arrow-pointing-to-the-right"></span></a>
									</div>
								</div>
							</div>
						</div>

						{/* <!-- News Block Three --> */}
						<div class="news-block-three style-two col-lg-4 col-md-6 col-sm-12">
							<div class="inner-box">
								
								<div class="image">
									<a href="/services/hire-chrome-extension-developer/"><img src={news_6} alt="" /></a>
								</div>
								<div class="lower-content">
									<div class="content">
										<div class="icon-box">
											<span class="icon flaticon-mobile-app"></span>
										</div>
										<h4><Link to="/services/hire-chrome-extension-developer/">Hire Chrome Extension Developer</Link></h4>
										<div class="text">We develop custom Chrome extensions that improve productivity, automate tasks, and enhance your browsing experience every day.</div>
										<a class="read-more" href="/services/hire-chrome-extension-developer/">Read More<span class="arrow flaticon-long-arrow-pointing-to-the-right"></span></a>
									</div>
								</div>
							</div>
						</div>

						{/* <!-- News Block Three --> */}
						<div class="news-block-three col-lg-4 col-md-6 col-sm-12">
							<div class="inner-box">
								<div class="image">
									<a href="/services/erp-development/"><img src={news_7} alt="" /></a>
								</div>
								<div class="lower-content">
									<div class="content">
										<div class="icon-box">
											<span class="icon flaticon-computer"></span>
										</div>
										<h4><Link to="/services/erp-development/">ERP system</Link></h4>
										<div class="text">An ERP (Enterprise Resource Planning) system integrates core business processes like finance, inventory, HR, and operations into a single platform to improve efficiency, accuracy, and decision-making.</div>
										<a class="read-more" href="/services/erp-development/">Read More<span class="arrow flaticon-long-arrow-pointing-to-the-right"></span></a>
									</div>
								</div>
							</div>
						</div>

						<div class="news-block-three col-lg-4 col-md-6 col-sm-12">
							<div class="inner-box">
								<div class="image">
									<a href="/services/mobile-app-development-modasa/"><img src={news_12} alt="" /></a>
								</div>
								<div class="lower-content">
									<div class="content">
										<div class="icon-box">
											<span class="icon flaticon-mobile-app"></span>
										</div>
										<h4><Link to="/services/mobile-app-development-modasa/">Mobile App Development Modasa</Link></h4>
										<div class="text">We build Android and iOS mobile apps with clean UI, practical features, and fast performance to support real business growth.</div>
										<a class="read-more" href="/services/mobile-app-development-modasa/">Read More<span class="arrow flaticon-long-arrow-pointing-to-the-right"></span></a>
									</div>
								</div>
							</div>
						</div>

						{/* <!-- News Block Three --> */}
						<div class="news-block-three col-lg-4 col-md-6 col-sm-12">
							<div class="inner-box">
								<div class="image">
									<a href="/contact/"><img src={news_11} alt="" /></a>
								</div>
								<div class="lower-content">
									<div class="content">
										<div class="icon-box">
											<span class="icon flaticon-web"></span>
										</div> 
										<h4><a href="/services/qa-testing/">QA & Testing</a></h4>
										<div class="text">Ensure flawless performance with our comprehensive QA & Testing services, designed to detect issues early and deliver reliable, high-quality software.</div>
										<a class="read-more" href="/services/qa-testing/">Read More<span class="arrow flaticon-long-arrow-pointing-to-the-right"></span></a>
									</div>
								</div>
							</div>
						</div>



						{/* <!-- News Block Three --> */}
						{/* <div class="news-block-three col-lg-4 col-md-6 col-sm-12">
							<div class="inner-box">
								<div class="image">
									<a href="/contact/"><img src={news_12} alt="" /></a>
								</div>
								<div class="lower-content">
									<div class="content">
										<div class="icon-box">
											<span class="icon flaticon-monitor-2"></span>
										</div>
										<h4><a href="/contact/">IT Consultancy</a></h4>
										<div class="text">At SwiftMaze, we deliver smart and secure IT solutions to help businesses grow, stay efficient, and compete in the digital world.</div>
										<a class="read-more" href="/contact/">Read More<span class="arrow flaticon-long-arrow-pointing-to-the-right"></span></a>
									</div>
								</div>
							</div>
						</div> */}

						{/* <!-- News Block Three --> */}
						<div class="news-block-three col-lg-4 col-md-6 col-sm-12">
							<div class="inner-box">
								<div class="image">
									<a href="/services/crm-development/"><img src={news_13} alt="" /></a>
								</div>
								<div class="lower-content">
									<div class="content">
										<div class="icon-box">
											<span class="icon flaticon-human-resources"></span>
										</div>
										<h4><a href="/services/crm-development/">CRM System</a></h4>
										<div class="text">Maximize customer data with our CRM to streamline sales, Accounting & finance & boost engagement, and drive growth.</div>
										<a class="read-more" href="/services/crm-development/">Read More<span class="arrow flaticon-long-arrow-pointing-to-the-right"></span></a>
									</div>
								</div>
							</div>
						</div>

						{/* Modasa */}
						<div class="news-block-three col-lg-4 col-md-6 col-sm-12">
							<div class="inner-box">
								<div class="image">
									<a href="/services/website-development-modasa/"><img src={news_11} alt="" /></a>
								</div>
								<div class="lower-content">
									<div class="content">
										<div class="icon-box">
											<span class="icon flaticon-web"></span>
										</div>
										<h4><a href="/services/website-development-modasa/">Website Development Modasa</a></h4>
										<div class="text">We build fast, mobile-responsive, and SEO-friendly websites for businesses in Modasa.</div>
										<a class="read-more" href="/services/website-development-modasa/">Read More<span class="arrow flaticon-long-arrow-pointing-to-the-right"></span></a>
									</div>
								</div>
							</div>
						</div>
						<div class="news-block-three col-lg-4 col-md-6 col-sm-12">
							<div class="inner-box">
								<div class="image">
									<a href="/services/digital-marketing-modasa/"><img src={news_11} alt="" /></a>
								</div>
								<div class="lower-content">
									<div class="content">
										<div class="icon-box">
											<span class="icon flaticon-web"></span>
										</div>
										<h4><a href="/services/digital-marketing-modasa/">Digital Marketing Modasa</a></h4>
										<div class="text">Our digital marketing services help businesses in Modasa increase online visibility and generate quality leads.</div>
										<a class="read-more" href="/services/digital-marketing-modasa/">Read More<span class="arrow flaticon-long-arrow-pointing-to-the-right"></span></a>
									</div>
								</div>
							</div>
						</div>
						<div class="news-block-three col-lg-4 col-md-6 col-sm-12">
							<div class="inner-box">
								<div class="image">
									<a href="/services/software-development-modasa/"><img src={news_11} alt="" /></a>
								</div>
								<div class="lower-content">
									<div class="content">
										<div class="icon-box">
											<span class="icon flaticon-web"></span>
										</div>
										<h4><a href="/services/software-development-modasa/">Software Development Modasa</a></h4>
										<div class="text">We develop custom software solutions for businesses in Modasa to automate processes and improve efficiency.</div>
										<a class="read-more" href="/services/software-development-modasa/">Read More<span class="arrow flaticon-long-arrow-pointing-to-the-right"></span></a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};

export default Service1;
